// src/hooks/useAuth.js (full fixed - default import)
import { useContext } from 'react'; // FIXED: useContext (not 'use'—React 18)
import { jwtDecode } from 'jwt-decode';
import JWTContext from '../contexts/JWTContext'; // FIXED: Default import (no {}—matches export default in JWTContext.jsx)

const useAuth = () => {
  const context = useContext(JWTContext); // FIXED: useContext (line 13—resolves null/use error)

  if (!context) {
    throw new Error('useAuth must be used inside JWTProvider');
  }

  // Token expiry check
  const isTokenExpired = () => {
    const token = localStorage.getItem('accessToken');
    if (!token) return true;
    try {
      const decoded = jwtDecode(token);
      return decoded.exp * 1000 < Date.now();
    } catch {
      return true;
    }
  };

  // Logout helper
  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    context.logout(); // Trigger context update
    window.location.href = '/login';
  };

  // Login helper (if not in context)
  const login = async (email, password) => {
    if (!email || !password) {
      throw new Error('Email and password required');
    }
    try {
      // FIXED: Wrap separate args in object for context.login
      const response = await context.login({ email: email.trim(), password });
      // FIXED: No extra storage/check—context handles on success; just return response
      return response;
    } catch (err) {
      console.error('Login error:', err);
      throw err;
    }
  };

  return {
    ...context, // isAuthenticated, user, isLoading, error
    login,
    logout,
    isTokenExpired
  };
};

export default useAuth;